export interface BannerConfig {
  message: string
  type: 'info' | 'notice' | 'warning' | 'critical' | 'success' | 'error'
  active: boolean
}

export const getBannerStyles = (type: string) => {
  switch (type) {
    case 'warning':
      return {
        backgroundColor: '#fff3cd',
        borderColor: '#ffeaa7',
        color: '#856404',
        borderLeft: '4px solid #ffc107'
      }
    case 'info':
      return {
        backgroundColor: '#d1ecf1',
        borderColor: '#bee5eb',
        color: '#0c5460',
        borderLeft: '4px solid #17a2b8'
      }
    case 'critical':
      return {
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb',
        color: '#721c24',
        borderLeft: '4px solid #dc3545'
      }
    case 'success':
      return {
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb',
        color: '#155724',
        borderLeft: '4px solid #28a745'
      }
    case 'error':
      return {
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb',
        color: '#721c24',
        borderLeft: '4px solid #e74c3c'
      }
    case 'notice':
    default:
      return {
        backgroundColor: '#fff3cd',
        borderColor: '#ffeaa7',
        color: '#856404',
        borderLeft: '4px solid #ffc107'
      }
  }
}

export const getBannerType = (type: string) => {
  switch (type) {
    case 'critical':
      return 'danger'
    case 'error':
      return 'danger'
    default:
      return type
  }
}

export const getIcon = (type: string) => {
  switch (type) {
    case 'warning':
      return 'warning'
    case 'info':
      return 'information-5'
    case 'critical':
      return 'shield-cross'
    case 'success':
      return 'check-circle'
    case 'error':
      return 'cross-circle'
    case 'notice':
    default:
      return 'information-5'
  }
} 